<template>
	<b-row class="content-element animated fadeIn">
    	<b-col style="padding:0">
			<div class="dv-separator">
            </div>
    	</b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element> 
	</b-row>
</template>
<style>
hr.style-seven {
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-color: #20a8d8;
    border-width: 1px 0 0 0;
    border-radius: 20px;
}
hr.style-seven:before { /* Not really supposed to work, but does */
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: #20a8d8;
    border-width: 0 0 1px 0;
    border-radius: 20px;
}
.dv-separator{ 
    height:3px; 
    width: 100%;
    background-color: #aaaaaa;
    margin-top: 12px;
}
</style>
<script>
import OptionsElement from './OptionsElement';
export default {
	name: 'Separator',
	props:{
        content: {
            type:String,
            default: ''//no toma los valores porque está embebido--ver bien el porqué
        },
		idElement: {type:Number}, // Se obtiene posición en el arreglo matriz
        idColumn: { type:Number, default: null }, // se obtiene posición de la columna en caso de que esté posicionada en una
	},
	components: {
		OptionsElement
	},
};	
</script>